export { default } from './MinimumCreditLimitUpdate'
